import React, { useEffect, useState } from 'react';
import ReusableTable from "../../../../components/TableCustomPagination";
import axios from 'axios';
import { Modal, Button, Form } from "react-bootstrap";
import Select from 'react-select';
import { ToastContainer, toast } from 'react-toastify';
import Editor from '../../../../components/editor';
import { API_URL } from '../../../../constants/index';
import { useSearchParams } from 'react-router-dom';
import { GetServiceCaller, PostFormServiceCaller } from '../../../../services/serviceCaller';
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";

const Anniversary = () => {
    const [searchParams] = useSearchParams();
    const page = searchParams.get('page');

    const [Anniversary, setAnniversary] = useState([]);
    const [pagination, setPagination] = useState({
        currentPage: page,
        total: '',
        perPage: 10,
        lastPage: ''
    })
    const [EmployeeListdata, setEmployeeListdata] = useState([]);
    const [aniversary, setaniversary] = useState([]);
    const [JuniorListdata, setJuniorListdata] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [NoOfProjectContent, setNoOfProjectContent] = useState('');
    const [isAdding, setIsAdding] = useState(false);
    const [value, setValue] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);
    const [fileName, setFileName] = useState(null);
    const [formData, setFormData] = useState({
        employee_id: '',
        manager_id: '',
        fileName: ''
    });
    const [errorMessage, setErrorMessage] = useState("");
    const [editId, setEditId] = useState(null);

    const handleChange = (selected, name) => {
        setFormData(prevState => ({
            ...prevState,
            [name]: selected
        }));


    };

    const columns = {
        code: { text: "Code", width: '7%' },
        name: { text: "Name", width: '15%' },
        manager: { text: "Manager", with: '15%' },
        joining_Date: { text: "DOJ", with: '10%' },
        manager_remark: { text: "Manager Remark", width: '15%' },
        employee_remark: { text: "Employee Remark", width: '20%' },
    };

    const defaultColumns = {
        code: true,
        name: true,
        manager: true,
        joining_Date: true,
        manager_remark: true,
        employee_remark: true,
    };
    const dispatch = useDispatch();
    useEffect(() => {
      dispatch(updateNavbarHeading("Work Anniversary"))
    }, [])
    const resetFormState = () => {
        setValue(null);
        setFileName("");
        setFormData({
            employee_id: '',
            manager_id: '',
            fileName: ''
        });
        setErrorMessage("");
    };

    const fetchAnniversary = async () => {
        try {
            const response = await GetServiceCaller(`${API_URL}anniversary?page=${page ? page : 1}`);
            const data = response.data.data;
            setAnniversary(data);
            setPagination({
                currentPage: page,
                total: response.data.total,
                perPage: 10,
                lastPage: response.data.last_page
            })
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };


    useEffect(() => {
        fetchAnniversary();
    }, []);

    const handleEditModalClose = () => {
        setShowEditModal(false);
    };

    const handleEditorChangeNoOfProject = (content) => {
        setNoOfProjectContent(content);
    };

    const handleFile = (file) => {
        const fileType = file.type;
        const fileSize = file.size;
        if (fileType !== 'image/png' && fileType !== 'image/jpeg') {
            setErrorMessage("Only PNG and JPEG formats are allowed.");
            return;
        }
        if (fileSize > 300 * 1024) { // 300 KB
            setErrorMessage("File size should be less than 300 KB.");
            return;
        }
        setErrorMessage("");
        const previewUrl = URL.createObjectURL(file);
        setFormData(prevState => ({
            ...prevState,
            fileName: file
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.employee_id || !formData.fileName) {
            setErrorMessage("Please select an employee and upload an image.");
            return;
        }
        const data = new FormData();
        data.append('EmployeeID', formData.employee_id?.value);
        data.append('BirthdayImage', formData.fileName);

        try {
            const config = {
                headers: {
                    'content-type': 'multipart/form-data',
                },
            };
            await PostFormServiceCaller(`${API_URL}birthday-card-store`, data, config);
            toast.success("Data submitted successfully!");
            setErrorMessage("");
            setShowEditModal(false);
            fetchAnniversary(); // Refresh the table data
        } catch (error) {
            toast.error("Error submitting data.");
            setErrorMessage("Error submitting data.");
            console.error('Error submitting data:', error);
        }
    };

    const handleEdit = async (id) => {
        setIsAdding(false);
        setEditId(id);
        setShowEditModal(true);

        try {
            const response = await GetServiceCaller(`${API_URL}birthday-card/${id.ID}`);
            const data = response?.data?.birthdaydetails;

            setValue({ value: data.EmployeeID, label: data.EmployeeName });
            setFileName(data.FileName);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const handleEmployee = () =>{
        setShowEditModal(true);
        resetFormState();
    }
    const handleManager = () =>{
        setShowEditModal(true);
        resetFormState();
    }

    return (
        <>
                <div className="container-fluid" id="skill_section">
                    {/* Table section */}
                    <div className="container-fluid" id="skill-table-area">
                        <div className="row">
                            <ReusableTable
                                url='/work-anniversary'
                                pagination={pagination}
                                data={Anniversary}
                                columns={columns}
                                defaultColumns={defaultColumns}
                                itemsPerPage={8}
                                isAddEmployeeReq={true}
                                isAddManagerReq={true}
                                searchTerm={searchTerm}
                                handleEmployeeReview={handleEmployee}
                                handleManagerReview={handleManager}
                                setSearchTerm={setSearchTerm}
                                customColumnClasses={{
                                    name: 'text-left', // Center align DateOfBirth
                                }}
                                handleEdit={handleEdit} // Pass handleEditClick to the table
                            />
                        </div>
                    </div>

                    <Modal show={showEditModal} onHide={handleEditModalClose} className='custom-modal' size="lg">
                        <Modal.Header closeButton>
                            <Modal.Title>
                                <h4>Work Anniversary</h4>
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Form onSubmit={handleSubmit}>
                                <div className='border p-3'>
                                    <div className='row'>
                                        <div className="col-12">
                                            <div className="row">
                                                <div className="col-md-3 mt-1">
                                                    <label htmlFor="refercandidatelist" className="form-label mt-1">
                                                        Employee Name
                                                    </label>
                                                    <div>
                                                        <Select
                                                            value={formData.employee_id}
                                                            name='employee_id'
                                                            className="basic-single"
                                                            classNamePrefix="select"
                                                            onChange={(selected) => handleChange(selected, 'employee_id')}
                                                            options={aniversary}
                                                            placeholder="Select Employee"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-4 mt-1">
                                                    <label htmlFor="refercandidatelist" className="form-label mt-1">
                                                        Manager Name
                                                    </label>
                                                    <div>
                                                        <Select
                                                            value={formData.manager_id}
                                                            name='manager_id'
                                                            className="basic-single"
                                                            classNamePrefix="select"
                                                            onChange={(selected) => handleChange(selected, 'manager_id')}
                                                            options={EmployeeListdata}
                                                            placeholder="Select Manager"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-4 mt-1">
                                                    <label htmlFor="refercandidatelist" className="form-label mt-1">
                                                        Employee Name
                                                    </label>
                                                    <div>
                                                        <Select
                                                            value={formData.employee_id}
                                                            name='employee_id'
                                                            className="basic-single"
                                                            classNamePrefix="select"
                                                            onChange={(selected) => handleChange(selected, 'employee_id')}
                                                            options={JuniorListdata}
                                                            placeholder="Select Employee"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="editor-section">
                                        <label htmlFor="refercandidatelist" className="form-label mt-1">
                                            Manager's Desk
                                        </label>
                                        <Editor onEditorChange={handleEditorChangeNoOfProject} />
                                    </div>
                                </div>
                                <div className="row mt-3">
                                    <div className="col-12 text-end">
                                        <Button type="submit" className="custom-btn">
                                            Submit
                                        </Button>
                                    </div>
                                </div>
                            </Form>
                        </Modal.Body>
                    </Modal>

                    <ToastContainer />
                </div>
        </>
    );
}

export default Anniversary;


